import React from 'react';
import { Control, Fieldset } from 'react-redux-form';
import {
  enumAnnualIncome,
  enumLiquidNetWorth,
  enumTotalNetWorth,
  PLACEHOLDER_OPT,
} from './Schemas/baseRrf';
import Select from './Controls/Select';
import InputField from './Controls/Field';
import withHint from './Controls/withHint';

const fields = [
  {
    model: '.annualIncome',
    RRFComp: Control,
    control: {
      component: withHint(
        Select,
        'Total amount of income earned annually before taxes.',
      ),
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select your Annual Income.',
      },
    },
  },
  {
    model: '.totalNetWorth',
    RRFComp: Control,
    control: {
      component: withHint(
        Select,
        'Net worth is what you own minus what you owe excluding your primary residence.',
      ),
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select your Total Net Worth.',
      },
    },
  },
  {
    model: '.liquidNetWorth',
    RRFComp: Control,
    control: {
      component: withHint(
        Select,
        'Liquid net worth is the part of your assets that can readily be turned into cash. This includes investments such as stocks and mutual funds but not real estate and cars.',
      ),
      errors: {
        required: val => !val || !val.length || val === PLACEHOLDER_OPT,
      },
    },
    error: {
      messages: {
        required: 'Please select your Liquid Net Worth.',
      },
    },
  },
];

const Finances = ({ financesPath }) => (
  <Fieldset model={financesPath}>
    <InputField key={fields[0].model} fieldProps={fields[0]}>
      {enumAnnualIncome.map(([key, value]) => (
        <option key={key} disabled={key === PLACEHOLDER_OPT} value={key}>{value}</option>
      ))}
    </InputField>
    <InputField key={fields[1].model} fieldProps={fields[1]}>
      {enumTotalNetWorth.map(([key, value]) => (
        <option key={key} disabled={key === PLACEHOLDER_OPT} value={key}>{value}</option>
      ))}
    </InputField>
    <InputField key={fields[2].model} fieldProps={fields[2]}>
      {enumLiquidNetWorth.map(([key, value]) => (
        <option key={key} disabled={key === PLACEHOLDER_OPT} value={key}>{value}</option>
      ))}
    </InputField>
  </Fieldset>
);

export default Finances;



// WEBPACK FOOTER //
// ./src/components/Forms/Finances.js